import { useAppStore } from '@/store/useAppStore.ts'
import { RangeSlider } from 'calc-controls'
import { HelpIcon } from '@/components/shared/HelpIcon.tsx'

export function SoCInput() {
  const soc = useAppStore((s) => s.battery.stateOfCharge)
  const capacity = useAppStore((s) => s.battery.capacityValue)
  const updateBattery = useAppStore((s) => s.updateBattery)

  const socPercent = Math.round(soc * 100)
  const availableAh = Math.round(capacity * soc * 100) / 100

  return (
    <div className="soc-input">
      <HelpIcon text="Current charge level as a fraction of full capacity. 100% means fully charged.">
        <span className="soc-input__label">State of Charge</span>
      </HelpIcon>
      <RangeSlider
        label="State of Charge"
        value={socPercent}
        onChange={(v) => updateBattery('stateOfCharge', v / 100)}
        min={0}
        max={100}
        step={1}
        decimals={0}
        unit="%"
      />
      <p className="soc-input__available">
        Available: {availableAh} Ah
      </p>
    </div>
  )
}
